var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeartHands = function SvgHeartHands(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.333 18.667c1.987-1.947 4-4.28 4-7.334A7.333 7.333 0 0 0 22 4c-2.347 0-4 .667-6 2.667C14 4.667 12.347 4 10 4a7.333 7.333 0 0 0-7.333 7.333c0 3.067 2 5.4 4 7.334L16 28l9.333-9.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16 6.667-3.947 3.947a2.894 2.894 0 0 0 0 4.106 2.9 2.9 0 0 0 4 .094l2.76-2.534a3.76 3.76 0 0 1 5.054 0l3.946 3.547M24 20l-2.667-2.667M20 24l-2.667-2.667"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeartHands);
export default ForwardRef;